import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { setLoading, showErrorModal, useApplicationState, updateApplicationTitle } from '../../utilities/applicationState';
import { SdfBox, SdfQuickStat } from '@synerg/react-components';
import ProjectListTable from './projectListTable';

export default function ProjectList() {
	const [, dispatch] = useApplicationState();
	// eslint-disable-next-line no-unused-vars
	const [moduleLoading, setModuleLoading] = useState(true);
	const [totalProjects, setTotalProjects] = useState(0);
	// eslint-disable-next-line no-unused-vars
	const [totalLiveProjects, setTotalLiveProjects] = useState(0);
	const [totalPartners, setTotalPartners] = useState(0);
	const [totalLegacyProjects, setTotalLegacyProjects] = useState(0);

	const getReports = async () => {
		try {
			dispatch(setLoading(true));
			const { data: { reports } } = await axios(`${import.meta.env.VITE_ROOT_PATH}/api/partner/projects/report`);
			setTotalProjects(reports.totalProjects);
			setTotalLiveProjects(reports.totalLiveProjects);
			setTotalPartners(reports.totalPartners);
			setTotalLegacyProjects(reports.totalLegacyProjects);
			setModuleLoading(false);
			dispatch(setLoading(false));
		} catch (e) {
			const errorMessage = get(e, 'response.data.message', 'Something went wrong when trying to get total partners reports. Please try again.');
			dispatch(showErrorModal(errorMessage));
		}
	};

	useEffect(() => {
		// change title on mount
		dispatch(updateApplicationTitle('Partner Projects'));
		getReports();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="partner-project-list-container mx-24 my-10">
			<div slot="breadcrumb" className="mb-5" onClick={() => { }}>
				Partner projects <span>/</span>
			</div>
			<span slot="title" className="text-heading-07 font-black">Partner projects</span>
			<SdfBox className="my-5 p-5">
				<div className=" details-container flex">
					<div className="w-2/5 flex items-center">
						<div className="text-heading-06 font-black">
							Quick stats
						</div>
					</div>
					<div className="grid sm:grid-cols-4 details-container gap-5 items-center">
						<div>
							<SdfQuickStat label="Total projects" size="lg" label-position="after">
								<span>{totalProjects}</span>
							</SdfQuickStat>
						</div>
						<div>
							<SdfQuickStat label="Legacy projects" size="lg" label-position="after">
								<span>{totalLegacyProjects}</span>
							</SdfQuickStat>
						</div>
						<div>
							<SdfQuickStat label="Projects published using self service" size="lg" label-position="after">
								<span>{totalProjects - totalLegacyProjects}</span>
							</SdfQuickStat>
						</div>
						<div>
							<SdfQuickStat label="Total partners" size="lg" label-position="after">
								<span>{totalPartners}</span>
							</SdfQuickStat>
						</div>
					</div>
				</div>
			</SdfBox>
			<ProjectListTable />
		</div>
	);
}
